import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { ILink } from 'tbk-components/src/components/Button';
import { IStep } from '.';

interface IStepI18nProps {
	step?: string;
}

export interface IStepperProps extends IBaseElementProps {
	steps: IStep[];
	current?: number;
	i18n?: IStepI18nProps;
}

const Stepper: React.FC<IStepperProps> = ({
	steps = [],
	current = 0,
	i18n,
	className,
	classNames = [],
}) => (
	<div className={className || cn('stepper', ...classNames)}>
		{Array.isArray(steps) && steps.length > 0 && (
			<div className="stepper__container">
				<div className="stepper__steps">
					{steps?.map((step, index) => {
						const s =
							current === index
								? 'current'
								: current > index
									? 'completed'
									: null;

						return (
							<div className="stepper__step" key={index}>
								{index > 0 && (
									<div className="stepper__step-connector">
										<span className="stepper__step-connector-line"></span>
									</div>
								)}
								<div className={`stepper__step-block ${s}`}>
									<span className="stepper__step-circle"></span>
									<div className="stepper__step-number">
										{i18n?.step || 'Step'} {index + 1}
									</div>
									<div className="stepper__step-title">
										{step.stepTitle}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		)}
	</div>
);

export default Stepper;
